<div fxLayout="row" fxFlexFill>
    <mat-form-field fxFlex="100">
        <input #tituloAnexo matInput maxlength="50" name="tituloAnexo_{{pinRandom}}"
               placeholder="Título" [(ngModel)]="conteudo.descricao" [disabled]="camposDesabilitados">
        <mat-hint align="end">{{ tituloAnexo.value.length }} / 50</mat-hint>
    </mat-form-field>

    <div style="margin-left: 26px;">
        <mat-checkbox color="primary"
                      title="Apêndice"
                      name="apendiceAnexo_{{pinRandom}}"
                      [(ngModel)]="conteudo.anexoApendice"
                      style="margin-top: 20px;" [disabled]="camposDesabilitados">
            Apêndice
        </mat-checkbox>
    </div>

</div>

<div fxLayout="row" fxFlexFill style="padding-bottom: 5px">
    <mat-form-field fxFlex="100">
        <input matInput maxlength="1000" name="nomeArquivoAnexo_{{pinRandom}}" readonly placeholder="Nome do Arquivo"
               value="{{conteudo.metadados?.nmArquivo}}" required [disabled]="camposDesabilitados">
    </mat-form-field>
    <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="10">
        <input matInput maxlength="1000" name="tipoArquivoAnexo_{{pinRandom}}" readonly placeholder="Tipo do Arquivo"
               value="{{conteudo.metadados?.dsTipoArquivo}}" required [disabled]="camposDesabilitados">
    </mat-form-field>
    <div fxLayoutAlign="start center" fxLayoutGap="5px"
         style="padding-top: 10px; padding-left: 20px; display: flex">
        <button matTooltip="Escolher Arquivo" mat-mini-fab color="primary" (click)="uploadFile.click()"
                style="width: 150px;border-radius: 5px;" *ngIf="!camposDesabilitados">
            <mat-icon>add</mat-icon>
            Escolher Arquivo
        </button>
        <button matTooltip="Baixar Arquivo" mat-mini-fab color="primary" (click)="baixarArquivo()"
                style="width: 50px;border-radius: 5px;" *ngIf="conteudo.metadados">
            <mat-icon>download</mat-icon>
        </button>
    </div>
    <input name="anexoInput_{{pinRandom}}" style="display:none;" (change)="fileChangeEvent($event)" #uploadFile type="file"
           accept=".pdf, .jpg, .jpeg, .png, .gif"/>
</div>